import * as constants from '../constants';

const initialState = false;

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.createInitialProtocol.try: {
            return true;
        }

        case constants.createInitialProtocol.success:
        case constants.createInitialProtocol.error: {
            return false;
        }

        default:
            return state;
    }
}